module.exports = __webpack_public_path__ + "static/img/slide1_h.d950d82.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide1_h.jpeg
// module id = uYPv
// module chunks = 1